module.exports = __webpack_public_path__ + "media/icons/icon-bar-4-466b87fe.png";